"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var NumberInputDirective = /** @class */ (function () {
    function NumberInputDirective() {
        this.keysOfNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        this.cKeyCode = 67;
        this.aKeyCode = 65;
        this.xKeyCode = 88;
        this.arrowRightKeyCode = 39;
        this.arrowLeftKeyCode = 37;
        this.backspaceKeyCode = 8;
    }
    NumberInputDirective.prototype.onNgModelChange = function (keyDownEvent) {
        var which = keyDownEvent.which;
        var isPressedCtrlCOrCtrlXOrCtrlA = keyDownEvent.ctrlKey && (which == this.cKeyCode || which == this.xKeyCode || which == this.aKeyCode);
        var isPressedNumber = this.keysOfNumbers.indexOf(keyDownEvent.key) !== -1;
        var isPressedArrowRight = which === this.arrowRightKeyCode;
        var isPressedArrowLeft = which === this.arrowLeftKeyCode;
        var isPressedBackspace = which === this.backspaceKeyCode;
        if (!isPressedBackspace && !isPressedArrowRight && !isPressedArrowLeft && !isPressedNumber &&
            !isPressedCtrlCOrCtrlXOrCtrlA && !keyDownEvent.ctrlKey && !keyDownEvent.shiftKey) {
            keyDownEvent.preventDefault();
        }
    };
    __decorate([
        core_1.HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], NumberInputDirective.prototype, "onNgModelChange", null);
    NumberInputDirective = __decorate([
        core_1.Directive({
            selector: '[number-input]',
        })
    ], NumberInputDirective);
    return NumberInputDirective;
}());
exports.NumberInputDirective = NumberInputDirective;
//# sourceMappingURL=number-input.directive.js.map